import { useQuery } from "react-query";
import { USE_QUERY_OPTIONS } from "../../dynamicForm/lib/constants";
import { useAxiosInstance } from "../../dynamicForm/hooks/useAxiosInstance";

export const usePendingWaterServiceConnections = (enabled = true) => {
  const axiosInstance = useAxiosInstance();

  return useQuery(
    ["pending-water-service-connection"],
    async () => {
      const { data } = await axiosInstance.get(
        `/pending-water-service-connection`
      );
      return data;
    },
    {
      ...USE_QUERY_OPTIONS,
      enabled,
    }
  );
};
